import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import EmployersClaim from "@/pages/EmployersClaim";

export const Route = createFileRoute("/employers/claim")({
  head: () => seoHead("/employers/claim"),
  component: EmployersClaim,
});
